import {replaceInChain} from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import {chain, ValidateCompanyName} from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import {AddressFieldDisplayModel} from "@insite/client-framework/Types/ApiModels";

const isEmpty = (value: string) => value.trim().length <= 0;

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

export const MONValidateCompanyName = (props: any) => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { companyName, properties: {oneTimeShipToType} }: any = props.parameter.address;

    if (
        addressFieldDisplayCollection.companyName?.isVisible &&
        validationRules.companyName?.isRequired &&
        isEmpty(companyName) &&
        !(oneTimeShipToType && oneTimeShipToType === "Residential")
    ) {
        props.addressErrors.companyName = getRequiredErrorMessage(addressFieldDisplayCollection.companyName);
    }
};

replaceInChain(chain, ValidateCompanyName, MONValidateCompanyName);